<template>
  <div>
    <loading
      :active.sync="isLoading"
      :can-cancel="false"
      :loader="'dots'"
      :height="150"
      :width="150"
      :color="'#F1557A'"
      :is-full-page="fullPage"
    ></loading>
    <sweet-modal ref="modal">
      <strong class="text-muted text-left d-block mb-2">Select Supporters</strong>
      <d-input-group class="mb-3">
        <multiselect
          :close-on-select="false"
          placeholder
          label="name"
          v-model="selectedSupporter"
          :multiple="true"
          track-by="name"
          :options="options"
        ></multiselect>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2">Select a Call-To-Action</strong>
      <d-input-group class="mb-3">
        <d-select :value="selectedCTA" @change="onchangeCta">
          <option>Support our new campaign - One-Time Donation</option>
          <option
            v-if="allCTA.length > 0"
            v-for="(cta, index) in allCTA"
            :key="index"
            v-bind:value="cta.id"
          >{{ cta.title + " - " + cta.type }}</option>
        </d-select>
      </d-input-group>
      <br />
      <br />
      <d-button @click.prevent="SendStory()" class="btn-blue btn-right">Send</d-button>
    </sweet-modal>
    <d-col
      v-for="(post, idx) in PostsListOne"
      v-if="idx < loadNum"
      :key="idx"
      lg="3"
      md="6"
      sm="12"
      class="mb-4"
    >
      <d-card class="card-small card-post card-post--1 video-card">
        <!-- <div
            :class="[`card-post__image wistia_embed wistia_async_${post.video_id}`]"
            style="width:100%;height:200px;"
        >&nbsp;</div>-->
        <div class="card-width">
          <!--<cld-video
            :publicId="`${post.video_id}`"
            controls="true"
            showLogo="false"
            analytics="false"
          >
            <cld-transformation
              gravity="auto"
              crop="fill"
              width="310"
              height="250"
              aspectRatio="1:1"
            />
          </cld-video>-->

          <video :id="`demo-player-${idx}`" class="cld-video-player" data-cld-show-logo="false"></video>
        </div>

        <d-card-body class="sent-to-card">
          <span
            class="timestamp"
          >{{post.admin ? post.admin.first_name : ''}} {{post.admin ? post.admin.last_name : ''}}</span>
          <span class="text-muted timestamp">{{moment(post.createdAt).format("MM/DD/YYYY hh:mm")}}</span>
        </d-card-body>
        <d-card-body class="stat-line">
          <d-button class="btn btn-blue btn-primary" @click="openModal(post._id)">Send Story</d-button>
          <d-button class="btn btn-primary btn-red ml-1" @click="deleteVideo(post._id)">Delete</d-button>
        </d-card-body>
      </d-card>
    </d-col>
    <!-- </d-row> -->
    <d-row v-if="this.prevPage && this.nextPage" class="load-more-row">
      <d-col v-if="this.prevPage" lg="6" md="6" sm="6" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous...</d-button>
        </span>
      </d-col>
      <d-col lg="6" md="6" sm="6" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More..</d-button>
        </span>
      </d-col>
    </d-row>
    <d-row v-if="!this.nextPage && this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadPreviousVideos()">Previous...</d-button>
        </span>
      </d-col>
    </d-row>
    <d-row v-if="this.nextPage && !this.prevPage" class="load-more-row">
      <d-col lg="12" md="12" sm="12" class="mb-4">
        <span class="load-more">
          <d-button class="btn btn-primary" @click="loadMoreVideos()">Load More..</d-button>
        </span>
      </d-col>
    </d-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import Avatar from "vue-avatar";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import supportersTypes from "../vuex/supporters/supporters.types";
import ctaTypes from "../vuex/cta/cta.types";
import Multiselect from "vue-multiselect";

// import "quill/dist/quill.snow.css";
Vue.use(Loading);
// First Row of Posts
const PostsListOne = [];

export default {
  data() {
    return {
      PostsListOne,
      selectedSupporter: [],
      SelectVideoID: null,
      allEmployees: [],
      options: [],
      selectedCTA: null,
      allCTA: [],
      isLoading: true,
      prevPage: null,
      page: 1,
      nextPage: null,
      loadNum: 12,
      player: null,
      fullPage: true,
      deleteAlert: false
    };
  },
  mounted() {
    analytics.track("Viewed Video Library");
    window._wq = window._wq || [];
    _wq.push({
      id: "5bbw8l7kl5",
      options: {
        autoPlay: false,
        //  videoFoam: true,
        controlsVisibleOnLoad: false,
        playbar: false,
        // email: "lennythedog@wistia.com",
        // endVideoBehavior: "loop",
        fullscreenButton: false,
        // googleAnalytics: true,
        //  qualityControl: false,
        volumeControl: true,
        settingsControl: false,
        playButton: true,
        playerColor: "#f2557a",
        // seo: true,
        // stillUrl: "https://my-awesome-website.com/my-thumbnail-url.jpg",
        // volume: 0.5,
        wmode: "transparent",
        doNotTrack: true
      }
    });
  },
  computed: {
    ...mapState({
      videoType: state => state.dash.type,
      fetchlibraryData: state => state.dash.fetchlibraryData,
      type: state => state.supporters.type,
      ctaType: state => state.cta.type,
      ctas: state => state.cta.data,
      data: state => state.supporters.data
    })
  },
  watch: {
    ctaType(type) {
      if (type == ctaTypes.FETCH_CTAS_SUCCESS) {
        this.allCTA = this.ctas.actions;
      }
    },
    type(newType) {
      if (newType === supportersTypes.FETCH_supporterS_SUCCESS) {
        let allSupporters = this.data.supporters;
        if (allSupporters && allSupporters.length) {
          allSupporters.map(item => {
            this.options.push({
              name: `${item.first_name} ${item.last_name}`,
              id: item._id,
              first_name: item.first_name,
              email: item.email,
              phone_number: item.phone_number
            });
          });
        }
        this.supporters = this.data.supporters.length;
        const tiers = this.tiersData.tiers || [];
        const tierNames = [];
        const data = [];
        tiers.forEach(tier =>
          tierNames.push({
            name: tier.name,
            level: tier.level
          })
        );
        if (this.data.supporters) {
          this.data.supporters.forEach(supporter => {
            tierNames.forEach(tierName => {
              if (supporter.level === tierName.level && !data[tierName.name]) {
                data[tierName.name] = 1;
              } else if (
                supporter.level === tierName.level &&
                data[tierName.name]
              ) {
                data[tierName.name] += 1;
              }
            });
          });
        }
        this.chartDatas = data;
      }
    },
    videoType(e) {
      if (e === "FETCH_VIDEOLIBRARY_SUCCESS") {
        this.isLoading = false;
        
        this.page = this.fetchlibraryData.page;
        this.nextPage = this.fetchlibraryData.nextPage;
        this.prevPage = this.fetchlibraryData.prevPage;
        this.PostsListOne = this.fetchlibraryData.docs;
        const cld = cloudinary.Cloudinary.new({
          cloud_name: "givemagic",
          secure: true
        });

        if (this.PostsListOne && this.PostsListOne.length) {
          setTimeout(() => {
            this.PostsListOne.map((item, index) => {
              this.player = cld.videoPlayer(`demo-player-${index}`, {
                showLogo: false,
                controls: true,
                colors: { accent: item.settings.primary_color },
                transformation: {
                  crop: "fill",
                  height: 268,
                  gravity: "auto",
                  aspectRatio: "1:1"
                },
                fluid: true
                //analytics: true
              });

              this.player.source(item.video_id, {
                colors: { accent: "green" },
                textTracks: {
                  captions: {
                    label: "English captions",
                    language: "en",
                    default: true,
                    url: item.video_subtitle
                  },
                  subtitles: [
                    {
                      label: "English subtitles",
                      language: "en",
                      url: item.video_subtitle
                    }
                  ]
                }
              });
            });
          }, 1000);
        }

        if (this.deleteAlert === true) {
          this.$toasted.success("Delete", {
            icon: "hourglass_empty",
            fullWidth: false,
            keepOnHover: true,
            duration: 3000,
            singleton: true,
            action: {
              text: "Close",
              onClick: (e, toastObject) => {
                toastObject.goAway(0);
              }
            }
          });
          this.deleteAlert = false;
        }
      } else if (e === "DELETE_VIDEO_REQUEST") {
        this.isLoading = true;
        this.deleteAlert = true;
        analytics.track("Video deleted");
        // this.PostsListOne = this.fetchData;
      } else if (e === "DELETE_VIDEO_SUCCESS") {
        this.PostsListOne = [];
        const  data = this.page
        this.$store.dispatch("fetchVideoLibrary",data);
      } else if (e === "DELETE_VIDEO_FAILED") {
        this.isLoading = false;
        this.$toasted.error(this.error, {
          icon: "error_outline",
          duration: 3000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (e == "FETCH_VIDEOLIBRARY_REQUEST") {
        this.isLoading = true;
      } else if (e == "SendLibraryVideo_Request") {
        this.isLoading = true;
      } else if (e == 'SendLibraryVideo_Sucess') {
        this.isLoading = false;
        this.$toasted.success("Send", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  methods: {
    onchangeCta(cta) {
      if (cta != "Support our new campaign - One-Time Donation") {
        this.selectedCTA = cta;
      } else {
        this.selectedCTA = null;
      }
    },
    loadMoreVideos() {
      // this.loadNum = this.loadNum + 8;
      if (this.nextPage) {
        this.PostsListOne = [];
        const data = this.nextPage;
        this.$store.dispatch("fetchVideoLibrary", data);
      }
    },
    openModal(id) {
      this.SelectVideoID = id;
      this.$refs.modal.open();
      analytics.track("Clicked Create To Do");
    },
    closeModal() {
      this.$refs.modal.close();
    },
    loadPreviousVideos() {
      if (this.prevPage) {
        this.PostsListOne = [];
        const data = this.prevPage;
        this.$store.dispatch("fetchVideoLibrary", data);
      }
    },
    moment: function(e) {
      return moment(e);
    },
    deleteVideo(deleteVideoId) {
      this.$store.dispatch("deleteVideo", deleteVideoId);
    },

    SendStory() {
      if (!this.selectedSupporter || !this.selectedSupporter.length) {
        alert("Please Select Supporters First");
      } else if (
        !this.selectedCTA ||
        this.selectedCTA == "Support our new campaign - One-Time Donation"
      ) {
        alert("Please Select CTA");
      } else {
        this.closeModal();
        if (this.selectedSupporter && this.selectedSupporter.length) {
          this.mySupporters = [];
          this.selectedSupporter.map(item => {
            this.mySupporters.push({
              id: item.id,
              firstname: item.first_name,
              email: item.email,
              phone: item.phone_number
            });
          });
        }
        var obj = {
          videoId: this.SelectVideoID,
          supporters: this.mySupporters,
          ctaId: this.selectedCTA
        };
        this.SelectVideoID = null;
        this.$store.dispatch("SendLibraryVideo", obj);
        analytics.track("Video Send From Library");
      }
    }
  },
  created() {
    const data = 1;
    this.$store.dispatch("fetchPendingVideo");
    this.$store.dispatch("fetchVideoLibrary", data);
    this.$store.dispatch("fetchsupporters");
    this.$store.dispatch("fetchAllCTA");
  },
  components: {
    Multiselect,
    Avatar,
    SweetModalTab,
    SweetModal,
    Loading
  }
};
</script>
<style lang="scss">
@import "../dist/vue-multiselect.min.css";
.message-to {
  font-size: 10px;
  text-transform: uppercase;
}

.sent-to-card {
  h6 {
    font-size: 1rem;
    margin-bottom: 0px;
    margin-top: 0px;
  }
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-top: 0.75rem !important;
}
.timestamp {
  font-size: 0.8rem !important;
}
.stat-line {
  font-size: 0.8rem !important;
}
.card-width {
  display: flex;
  overflow: hidden;
  height: 308px !important;
}
.card-post__image {
  min-height: 10.3125rem;
}
.card-post__author {
  position: relative !important;
  left: 0px;
  bottom: 10px !important;
  margin-top: 0px;
}
.card-post__author-avatar--small {
  width: 3.1875rem;
  height: 3.1875rem;
}
.card-small {
  box-shadow: 0 2px 0 rgba(90, 97, 105, 0.11), 0 4px 8px rgba(90, 97, 105, 0.12),
    0 10px 10px rgba(90, 97, 105, 0.06), 0 7px 70px rgba(90, 97, 105, 0.1);
  background: #fff;
}
.video-card {
  position: relative;
  width: auto;
}

.play-button {
  position: absolute;
  z-index: 10001;
  left: 28%;
  top: 10%;
  cursor: pointer;
  background: linear-gradient(#f4f5f8, #f1f3f6);
}

.stat-line {
  padding: 5px !important;
  margin: 0 auto;
  background: #f0f0f1;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  font-size: 1.2em;
  color: #212143;
}
.stat-line-stat {
  padding: 4px;
  text-align: center;
}
</style>
